module.exports = __webpack_public_path__ + "img/nav-right-with-contact-default.0eab899f.png";